export default __webpack_public_path__ + "static/media/kokoro.6a5415f7.mov";